import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  class: "right-menu"
};
const _hoisted_3 = {
  class: "avatar-wrapper"
};
const _hoisted_4 = {
  target: "_blank",
  href: ""
};
import 'vue';
import { useStore } from 'vuex';
import Hamburger from '@/components/Hamburger/index.vue';
import Breadcrumb from '@/components/Breadcrumb/index.vue';
import LangSelect from '@/components/LangSelect/index.vue';
import ThemeSelect from '@/components/ThemeSelect/index.vue';
import Screenfull from '@/components/Screenfull/index.vue';
import HeaderSearch from '@/components/HeaderSearch/index.vue';
import Guide from '@/components/Guide/index.vue';
export default {
  __name: 'Navbar',
  setup(__props) {
    const store = useStore();

    // 退出登录
    const logout = () => {
      store.dispatch('user/logout');
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Hamburger, {
        class: "hamburger-container"
      }), _createVNode(Breadcrumb, {
        id: "guide-breadcrumb",
        class: "breadcrumb-container"
      }), _createElementVNode("div", _hoisted_2, [_createVNode(Guide, {
        class: "right-menu-item hover-effect"
      }), _createVNode(HeaderSearch, {
        class: "right-menu-item hover-effect"
      }), _createVNode(Screenfull, {
        class: "right-menu-item hover-effect"
      }), _createVNode(ThemeSelect, {
        class: "right-menu-item hover-effect"
      }), _createVNode(LangSelect, {
        class: "right-menu-item hover-effect"
      }), _createVNode(_component_el_dropdown, {
        class: "avatar-container",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "user-dropdown"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: "/"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('msg.navBar.home')), 1)]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("a", _hoisted_4, [_createVNode(_component_el_dropdown_item, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('msg.navBar.course')), 1)]),
            _: 1
          })]), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: logout
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('msg.navBar.logout')), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
          shape: "square",
          size: 40,
          src: _ctx.$store.getters.userInfo.avatar
        }, null, 8, ["src"]), _cache[0] || (_cache[0] = _createElementVNode("i", {
          class: "el-icon-s-tools"
        }, null, -1))])]),
        _: 1
      })])]);
    };
  }
};